export const hasMarketingConsent = (): boolean => window.Cookiebot?.consent?.marketing === true;
